import z from 'zod';
import { IFieldErrors, ValidationError } from 'src/types/validation';

const NameTitleSchema = z.object({
  name: z.string().min(1),
  title: z.string().min(1)
});

export interface INameTitle {
  name: string;
  title: string;
}

//update: Partial<IRoom>
export const getSchema = () => {
  return NameTitleSchema;
};

export const validate = (update: Partial<INameTitle>): INameTitle => {
  const schema = getSchema();
  try {
    // Ensure there are changes from the original record
    const validated = schema.parse(update);
    return {
      ...validated
    };
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const errors: IFieldErrors = error.format();
      throw new ValidationError(errors);
    }
    throw new Error(error?.message || '');
  }
};